// Message

// const Message = function (pickedTemplate, target, User, APP_NAME, Store, Helper) {
const Message = function (options) {
  this.properties = options.template
  this.properties.imageFile = null
  this.retrievedProperties = null
  this.trade = options.tradeType
  this.target = options.target || document.querySelector('#visualisation-holder-reduced') || null
  this.User = options.user
  this.APP_NAME = options.appName
  this.Store = options.store
  this.Helper = options.helper
  this.errArr = []
  // types autorisés pour les images :
  this.IMAGE_ALLOWED_TYPES = ['image/png','image/jpg','image/jpeg'];
  // taille limite pour les images : 1 Mo (1048576 octets)
  this.IMAGE_MAX_SIZE = 1048576;
}


Message.prototype.triggerErrModal = function () {
  var self = this
  // 
  this.Helper.backdrop.hide('#app', this.properties.id)
  var errModalContent = document.querySelector('#error-modal-content > ul')
  errModalContent.innerHTML = ''
  if (this.errArr.length > 0 && errModalContent.outerHTML.length > 0) {
    for (var i in this.errArr) {
      var element = document.createElement('LI')
      var err = document.createTextNode(this.errArr[i])
      element.appendChild(err)
      errModalContent.appendChild(element)
    }
    document.querySelector('#modalButton').click()
    this.errArr = []
  }
}

Message.prototype.init = function () {
  console.log('Message Init');

  this.Store.setMessage(this)

  var documentBody = document.querySelector('body')
  var renderDivs = documentBody.querySelectorAll('.message-render')
  Array.prototype.forEach.call(renderDivs, function (item) {
    if (item) {
      documentBody.removeChild(item)
    }
  })
  // - - - - - - - - - - - - -
  var button = document.querySelector('#set-message-compo')
  button.style.cursor = 'pointer'
  button.addEventListener('click', e => {
    if (this.Store.get('pickedTemplate') === this.properties.id) {
      this.renderMessage()
    }    
  }, false)
  // - - - - - - - - - - - - -
  return new Promise((resolve, reject) => {
    return this.Store.retrieveMessage(this.properties.id, (err, retrievedProperties) => {
      if (err) {
        console.error(err)
        reject(err)
      }      
      resolve(retrievedProperties)
    })
  }).then(retrievedProperties => {
    if (retrievedProperties) {
      this.properties = retrievedProperties
      return true
    }
  }).then(success => {
    // - - - - - - - - - - - - -
    var messageContainer = document.createElement('DIV')
    messageContainer.classList.add('visualisation')
    //
    messageContainer.dataset.templateIndex = this.properties.id
    //
    this.target.appendChild(messageContainer)
    //
    if ((!this.Store.get('pickedTemplate') || this.Store.get('pickedTemplate') == 0) && this.properties.id == 0) {
      setTimeout(() => {
        messageContainer.classList.add('template-active')
      }, 0)
    }
    // 
    if (typeof this.Store.get('pickedTemplate') == 'number' && this.Store.get('pickedTemplate') == this.properties.id) {
      setTimeout(() => {
        messageContainer.classList.add('template-active')
      }, 0)
    }
    // - - - - - - - - - - - - -
    var mainContainer = document.createElement('DIV')
    mainContainer.classList.add('main-container') 
    var messageRender = document.createElement('DIV')
    messageRender.classList.add('message-render')
    messageRender.setAttribute('id', 'message-render-' + this.properties.id)

    for (style in this.properties.fullStyle.backgroundStyle) {
      let prop = this.properties.fullStyle.backgroundStyle[style]
      if (typeof prop === 'object') {
        prop = prop[this.trade]
      }
      mainContainer.style[style] = prop
      messageRender.style[style] = prop
    }
    // - - - - - - - - - - - - -
    if (this.properties.reducedStyle.whiteMaskStyle) {
      var whiteMask = document.createElement('DIV')
      whiteMask.classList.add('white-mask')
      for (style in this.properties.reducedStyle.whiteMaskStyle) {
        let prop = this.properties.reducedStyle.whiteMaskStyle[style]
        if (typeof prop === 'object') {
          prop = prop[this.trade]
        }
        whiteMask.style[style] = prop
      }
      messageContainer.appendChild(whiteMask)
      //
      var whiteMaskRender = document.createElement('DIV')
      whiteMaskRender.classList.add('white-mask')
      for (style in this.properties.fullStyle.whiteMaskStyle) {
        let prop = this.properties.fullStyle.whiteMaskStyle[style]
        if (typeof prop === 'object') {
          prop = prop[this.trade]
        }
        whiteMaskRender.style[style] = prop
      }
      messageRender.appendChild(whiteMaskRender)
    }
    // - - - - - - - - - - - - -
    if (this.properties.reducedStyle.imageInput && this.properties.reducedStyle.imageInput.shouldCheck) {    
      //
      var imageInput = document.createElement('DIV')
      imageInput.classList.add('image-input')
      for (style in this.properties.reducedStyle.imageInputStyle) {
        let prop = this.properties.reducedStyle.imageInputStyle[style]
        if (typeof prop === 'object') {
          prop = prop[this.trade]
        }
        imageInput.style[style] = prop
      }
      //
      if (this.properties
        && this.properties.fullStyle.imageInput.content
        && this.properties.fullStyle.imageInput.content.length > 0) {
        imageInput.style.backgroundImage = 'url(' + this.properties.fullStyle.imageInput.content + ')'
        imageInput.style.backgroundSize = 'cover'
        imageInput.style.backgroundPosition = '50% 50%'
      }
      //
      var label = document.createElement('LABEL')
      label.setAttribute('for', 'upload' + this.properties.id)
      label.classList.add('image-input-placeholder')
      for (style in this.properties.reducedStyle.imageInputPlaceholderStyle) {
        let prop = this.properties.reducedStyle.imageInputPlaceholderStyle[style]
        if (typeof prop === 'object') {
          prop = prop[this.trade]
        }
        label.style[style] = prop
      }
      //
      var span = document.createElement('SPAN')
      if (this.properties.fullStyle.imageInput.content && this.properties.fullStyle.imageInput.content.length > 0) {
        this.properties.reducedStyle.imageInputPlaceholderHTML = '<br/>'
      }
      span.innerHTML = this.properties.reducedStyle.imageInputPlaceholderHTML
      //
      var fileInput = document.createElement('INPUT')
      fileInput.setAttribute('id', 'upload' + this.properties.id)
      fileInput.setAttribute('type', 'file')
      fileInput.style.display = 'none'
      //
      label.appendChild(span)
      imageInput.appendChild(label)
      imageInput.appendChild(fileInput)
      mainContainer.appendChild(imageInput)
      //
      var imageRender = document.createElement('DIV')
      imageRender.setAttribute('id', 'image-input-render-' + this.properties.id)
      for (style in this.properties.fullStyle.imageInputStyle) {
        imageRender.style[style] = this.properties.fullStyle.imageInputStyle[style]
      }
      // 
      if (this.properties
        && this.properties.fullStyle.imageInput.content
        && this.properties.fullStyle.imageInput.content.length > 0) {
        imageRender.style.backgroundImage = 'url(' + this.properties.fullStyle.imageInput.content + ')'
        imageRender.style.backgroundSize = 'cover'
        imageRender.style.backgroundPosition = '50% 50%'
      }
      //
      messageRender.appendChild(imageRender)
      // change
      const handleFileInput = e => {
        return this.fileHandle(imageInput, label, imageRender, e.target.files[0])
      }
      fileInput.addEventListener('change', handleFileInput, false)
      // dragover
      imageInput.addEventListener('dragover', e => {
        e.stopPropagation()
        e.preventDefault()
        e.dataTransfer.dropEffect = 'copy'
        imageInput.style.border = this.properties.reducedStyle.imageInput.hoverBorderStyles.border
      }, false)
      // dragleave
      imageInput.addEventListener('dragleave', e => {
        imageInput.style.border = 'none'
      }, false)
      // drop
      imageInput.addEventListener('drop', e => {
        imageInput.style.border = 'none'
        e.preventDefault()
        e.stopPropagation()
        var files = e.dataTransfer.files
        return this.fileHandle(imageInput, label, imageRender, files[0])
      }, false)
      // 
    }
    // - - - - - - - - - - - - -
    if (this.properties.reducedStyle.title.shouldCheck) {
      var titleInput = document.createElement('INPUT')
      titleInput.setAttribute('type', 'text')
      titleInput.classList.add('title-input')
      if (this.properties.fullStyle.title.html && this.properties.fullStyle.title.html.length > 0) {
        titleInput.value = this.properties.fullStyle.title.html
      } else {
        titleInput.value = this.properties.reducedStyle.title.defaultHtml 
      }      
      for (style in this.properties.reducedStyle.titleStyle) {
        let prop = this.properties.reducedStyle.titleStyle[style]
        if (typeof prop === 'object') {
          prop = prop[this.trade]
        }
        console.debug('====> prop reduced title', this.properties.id, '-', prop, '-', this.trade)
        titleInput.style[style] = prop
      }
      mainContainer.appendChild(titleInput)
      //
      var titleRender = document.createElement('DIV')
      titleRender.setAttribute('id', 'title-render-' + this.properties.id)
      titleRender.classList.add('title-input')
      if (this.properties.fullStyle.title.html && this.properties.fullStyle.title.html.length > 0) {
        titleRender.innerHTML = this.properties.fullStyle.title.html
      } else {
        titleRender.innerHTML = this.properties.reducedStyle.title.defaultHtml 
      }
      for (style in this.properties.fullStyle.titleStyle) {
        let prop = this.properties.fullStyle.titleStyle[style]
        if (typeof prop === 'object') {
          prop = prop[this.trade]
        }
        console.debug('====> prop full title', this.properties.id, '-', prop, '-', this.trade)
        titleRender.style[style] = prop
      }
      messageRender.appendChild(titleRender)
      //
      var updateTitleRender = (source, target) => {
        var titleRenderValue = document.createTextNode(source.value)
        target.innerHTML = ''
        target.appendChild(titleRenderValue)
      }
      // 
      titleInput.addEventListener('keyup', e => {
        let value = e.target.value
        if (this.properties.reducedStyle.title.lengthLimit) {
          var limit = this.properties.reducedStyle.title.lengthLimit
          if (value.length > limit) {
            e.target.blur()
            e.target.value = value.substring(0, limit)
            this.errArr.push('Votre titre ne peut dépasser ' + limit + ' caractères')
            return this.triggerErrModal()
          }
        }
        updateTitleRender(e.target, titleRender)
      }, false)
      //
      titleInput.addEventListener('focus', e => {
        let value = e.target.value
        if (value === 'Votre Titre') {
          e.target.value = ''
          updateTitleRender(e.target, titleRender)
        }
      }, false)
      //
      titleInput.addEventListener('blur', e => {
        let value = e.target.value
        if (value.length === 0 || value.replace(/\s/g, '').length === 0) {
          e.target.value = this.properties.reducedStyle.title.defaultHtml
        } else {
          this.properties.fullStyle.title.html = value
          this.Store.saveMessage(this.properties.id, (err, success) => {
            if (err) {
              console.error(err)
              return false
            }
            return true
          })
        }
      }, false)
    }
    // - - - - - - - - - - - - -
    if (this.properties.reducedStyle.mainText.shouldCheck) {
      this.mainText = document.createElement('DIV')
      this.mainText.setAttribute('id', 'main-text-' + this.properties.id)
      // this.mainText.setAttribute('contenteditable', true)
      this.mainText.classList.add('main-text-style')    
      for (style in this.properties.reducedStyle.mainTextStyle) {
        let prop = this.properties.reducedStyle.mainTextStyle[style]
        if (typeof prop === 'object') {
          prop = prop[this.trade]
        }
        this.mainText.style[style] = prop
      }
      // 
      if (this.properties.reducedStyle.mainText.html && this.properties.reducedStyle.mainText.html.length > 0) {
        this.mainText.innerHTML = this.properties.reducedStyle.mainText.html
      }
      // 
      mainContainer.appendChild(this.mainText)
      //
      this.mainTextRender = document.createElement('DIV')
      this.mainTextRender.setAttribute('id', 'main-text-render-' + this.properties.id)
      this.mainTextRender.setAttribute('contenteditable', true)
      this.mainTextRender.classList.add('main-text-style')
      for (style in this.properties.fullStyle.mainTextStyle) {
        let prop = this.properties.fullStyle.mainTextStyle[style]
        if (typeof prop === 'object') {
          prop = prop[this.trade]
        }
        this.mainTextRender.style[style] = prop
      }
      // 
      if (this.properties.fullStyle.mainText.html && this.properties.fullStyle.mainText.html.length > 0) {
        this.mainTextRender.innerHTML = this.properties.fullStyle.mainText.html
      }
      // 
      messageRender.appendChild(this.mainTextRender)
    }
    // - - - - - - - - - - - - -
    messageContainer.appendChild(mainContainer)
    // messageContainer.appendChild(messageRender)
    document.querySelector('body').appendChild(messageRender)
    // - - - - - - - - - - - - -
    // this.tempNode = document.createElement('DIV')
    // this.tempNode.setAttribute('id', 'temp-node-' + this.properties.id)
    // this.tempNode.style.fontSize = '18px'
    // this.tempNode.style.position = 'absolute'
    // this.tempNode.style.top = '-10000px'
    // tempHolder.appendChild(this.tempNode)
    // - - - - - - - - - - - - -
    // if (this.properties.reducedStyle.mainText && this.properties.reducedStyle.mainText.shouldCheck) {
    //   this.initTextEditor()
    // }
    // - - - - - - - - - - - - -
    if (this.properties.reducedStyle.mainText.shouldCheck) {
      // keyup
      this.mainText.addEventListener('keyup', e => {
        this.updateMainTextRender(this.mainText, this.mainTextRender)
      }, false)
      // blur
      this.mainText.addEventListener('blur', e => {
        this.updateMainTextRender(this.mainText, this.mainTextRender)
        this.properties.reducedStyle.mainText.html = this.mainText.innerHTML
        this.properties.fullStyle.mainText.html = this.mainTextRender.innerHTML
        this.Store.saveMessage(this.properties.id, (err, success) => {
          if (err) {
            console.error(err)
            return false
          }
          return true
        })
      }, false)

      const mainTextLimit = (target) => {
        console.debug('===> this.properties', this.properties)
        if (this.properties.reducedStyle.mainText.lengthLimit) {
          var limit = this.properties.reducedStyle.mainText.lengthLimit
          if (target.textContent.length > limit) {
            target.blur()
            target.textContent = target.textContent.substring(0, limit)
            this.errArr.push('Votre texte ne peut dépasser ' + limit + ' caractères')
            this.triggerErrModal()
          }
        }      
      }
      // keyup
      this.mainText.addEventListener('keyup', e => {
        mainTextLimit(e.target)
      }, false)
      // paste
      this.mainText.onpaste = function () {
        mainTextLimit(e.target)
      }
      // focus
      this.mainText.addEventListener('focus', e => {
        var toBeRemoved = []
        var paragraphs = e.target.querySelectorAll('p')
        paragraphs.forEach(paragraph => {
          paragraph.removeAttribute('placeholder')
          if (paragraph.innerHTML.replace(/\s/g, '').length === 0) {
            toBeRemoved.push(paragraph)
          }
        })
        // 
        toBeRemoved.forEach(paragraph => {
          this.mainText.removeChild(paragraph)
        })
        //
      }, false)
      // - - - - - - - - - - - - -
      if (this.properties.reducedStyle.mainText && this.properties.reducedStyle.mainText.shouldCheck) {
        this.initTextEditor()
      }
    }
    return
  }).catch(err => {
    console.error('Message init error ', err)
  })
}


Message.prototype.getBase64Media = function (userProps, media, Callback) {
  return this.User.getBase64Media(userProps, media, function (err, base64Media) {
    if (err) {
      console.error(err)
      return Callback(err)
    }
    return Callback(null, base64Media)
  })
}


Message.prototype.storeReuseableMessage = function (router) {
  this.Store.set('pickedTemplate', this.properties.id)
  this.Store.setMessage(this)
  this.Store.saveMessage(this.properties.id, function (err, success) {
    if (err) {
      console.error(err)
      return false
    }
    //
    if (router) {
      return router.replace('/app/creer-un-message')
    }
    return window.location.replace('/app/creer-un-message')
  })
}


Message.prototype.fileHandle = function  (imageInput, imageInputPlaceholder, imageRender, file) {
  var self = this
  var reader = new FileReader()
  function checkImageFileSize () {
    if (file.size > self.IMAGE_MAX_SIZE && self.properties.reducedStyle.imageInput.shouldCheck) {
      self.errArr.push('L\'image choisie est trop volumineuse. ( maximum 1 méga-octet )')
      self.triggerErrModal()
      return false
    }
    return true
  }
  //
  if (!self.IMAGE_ALLOWED_TYPES.includes(file.type)) {
    self.errArr.push('Type de fichier non valide (autorisés : jpg, jpeg, png)')
    self.triggerErrModal()
    return false
  }
  // 
  if (checkImageFileSize()) {
    reader.onload = (function (theFile) {
      return function (e) {
        self.properties.fullStyle.imageInput.content = e.target.result
        self.Store.saveMessage(self.properties.id, function (err, success) {
          if (err) {
            console.error(err)
            return false
          }
          imageInput.style.backgroundImage = 'url(' + e.target.result + ')'
          imageInput.style.backgroundSize = 'cover'
          imageInput.style.backgroundPosition = '50% 50%'
          //
          imageRender.style.backgroundImage = 'url(' + e.target.result + ')'
          imageRender.style.backgroundSize = 'cover'
          imageRender.style.backgroundPosition = '50% 50%'
          //
          imageInputPlaceholder.innerHTML = self.properties.reducedStyle.imageInputPlaceholderHTML = '<br/>'
          return true
        })
      }
    })(file)
    reader.readAsDataURL(file)
  }
}


Message.prototype.checkSavedData = function (Callback) {
  var self = this
  var promisesArr = []
  var itemsToCheck = {
    title: this.properties.fullStyle.title.html,
    mainText: this.properties.fullStyle.mainText.html,
    imageFile: this.properties.fullStyle.imageInput.content
  }
  //
  function checkTitleExists () {
    return new Promise(function (resolve, reject) {
      if (self.properties.reducedStyle.title.shouldCheck && self.properties.fullStyle.title.html.length == 0) {
        self.errArr.push('La saisie d\'un titre est obligatoire')
      }
      return resolve()
    })
  }
  //
  function checkMainTextExists () {
    return new Promise(function (resolve, reject) {
      if (self.properties.reducedStyle.mainText.shouldCheck && self.properties.fullStyle.mainText.html.length == 0) {
        self.errArr.push('La saisie d\'un texte est obligatoire')
      }
      return resolve()
    })
  }
  // 
  function checkImageFileExists () {
    return new Promise(function (resolve, reject) {
      if (self.properties.reducedStyle.imageInput.shouldCheck 
        && ((!self.properties.fullStyle.imageInput.content || self.properties.fullStyle.imageInput.content.length === 0))) {
        self.errArr.push('Le choix d\'une image est obligatoire')
      }
      return resolve()      
    })
  }
  //
  for (i in itemsToCheck) {
    switch (i) {
      case 'title':
        promisesArr.push(checkTitleExists())
        break
      case 'mainText':
        promisesArr.push(checkMainTextExists())
        break
      case 'imageFile':
        promisesArr.push(checkImageFileExists())
        break
    }
  } 
  // 
  return Promise.all(promisesArr)
    .then(function (err, res) {
      return self.errArr.length
    }).then(function (nbErrors) {
      if (nbErrors) {
        self.triggerErrModal()
      }
      return Callback(null, nbErrors)
    }).catch(function (err) {
      console.error(err)
      return Callback(err)
    })
}


Message.prototype.renderMessage = function(e) {
  var self = this
  var image = new Image()
  //
  messageRender = document.querySelector('#message-render-' + this.properties.id)
  // 
  if (messageRender) {
    let documentBody = document.querySelector('body')
    this.Helper.backdrop.show('#app', this.properties.id)
    // TODO reprise de données
    // doc: http://html2canvas.hertzen.com
    return window.html2canvas(messageRender, {
      allowTaint: true,
      letterRendering: true,
      useCORS: true,
      onrendered: function (canvas) {
        return new Promise(function (resolve, reject) {
          return self.checkSavedData(function (err, nbErrors) {
            if (err) {
              console.log('/////////////////////////////// checkSavedData')
              self.Helper.backdrop.hide('#app', self.properties.id)
              return reject(err)
            }
            return resolve(nbErrors)
          })
        }).then(function (nbErrors) {
          if (nbErrors == 0) {
            try {
              image.src = canvas.toDataURL('image/png')
            }
            catch(err) {
              console.log('/////////////////////////////// toDataURL')
              console.error(err)
              self.errArr.push('Une erreur inattendue est survenue. Merci de réessayer dans quelques temps et de nous contacter si le problème persiste.')
              self.triggerErrModal()
              return err;
            }
            // 
            // proofing - - - - - - - - - - - - 
            // image.style.position = 'absolute'
            // documentBody.prepend(image)
            // 
            return self.Store.retrieveMessage(self.properties.id, function (err, messageProps) {
              if (err) {
                console.log('/////////////////////////////// retrieveMessage')
                self.Helper.backdrop.hide('#app', self.properties.id)
                console.error(err)
                self.errArr.push('Une erreur est survenue')
                self.triggerErrModal()
                return err;
              }
              messageProps.finalMessage = image.src
              return self.User.saveMedia(messageProps, function (err, respStatus, respData) {
                if (err) {
                  console.log('/////////////////////////////// saveMedia')
                  console.error(err)
                  if (err.response && err.response.data && err.response.data.code === 'MediaSpecs') {
                    self.errArr.push('Votre message ne respecte pas les spécifications requises et ne peut pas être enregistré.')
                  } else {
                    self.errArr.push('Une erreur inattendue est survenue. Merci de réessayer dans quelques temps et de nous contacter si le problème persiste.')
                  }
                  self.triggerErrModal()
                  return err;
                }
                return self.User.getProperties(function (err, newUserProps) {
                  if (err) {
                    console.log('/////////////////////////////// getProperties')
                    self.Helper.backdrop.hide('#app', self.properties.id)
                    console.error(err)
                    self.errArr.push('Une erreur est survenue')
                    self.triggerErrModal()
                    return err;
                  }
                  // 
                  // console.log(`////////////////////////////////////////// userProps.newUserProps.medias from Message : ${JSON.stringify(newUserProps.appData.medias, null, 4)}`)
                  // 
                  var renderDivs = documentBody.querySelectorAll('.message-render')
                  Array.prototype.forEach.call(renderDivs, function (item) {
                    if (item) {
                      documentBody.removeChild(item)
                    }
                  })
                  console.log('/////////////////////////////// renderDivs')
                  self.Helper.backdrop.hide('#app', self.properties.id)
                  if (self.User && self.User.router) {
                    return self.User.router.replace('/app/gerer-diffusion')
                  }
                  return window.location.replace('/app/gerer-diffusion')
                });
              })
            })
          }
        }).catch(function (err) {
          console.log('/////////////////////////////// catch error')
          self.Helper.backdrop.hide('#app', self.properties.id)
          console.error(err)
          return
        })
      }
    })
  }
}


Message.prototype.reuseMainTextHtml = function (source) {
  // 
  function loopThroughNodes (currentNode) {
    var allowedTags = [
      'TEXT',
      'P',
      'SPAN',
      'EM',
      'STRONG'
    ]
    // 
    var sourceElements = Array.prototype.filter.call(currentNode.childNodes, function (childNode) {
      return allowedTags.indexOf(childNode.nodeName) > -1
    })
    // 
    Array.prototype.forEach.call(sourceElements, function (node) {
      if (node.style) {
        loopThroughNodes(node)
        // 
        var fontSize = parseInt(node.style.fontSize)
        if (fontSize) {
            node.style.fontSize = Math.round(fontSize / 2) + 'px'
          }
      }
    })
    return currentNode.innerHTML
  }
  //
  var parser = new DOMParser()
  var doc = parser.parseFromString(source, "text/html").getElementsByTagName('html')[0].getElementsByTagName('body')[0]
  //
  return loopThroughNodes(doc)
}


Message.prototype.cleanUpTinyMceHtml = function (source) {

  function loopThroughNodes (currentNode) {
    var allowedTags = [
      'TEXT',
      'P',
      'SPAN',
      'EM',
      'STRONG'
    ]
    // 
    var sourceElements = Array.prototype.filter.call(currentNode.childNodes, function (childNode) {
      return allowedTags.indexOf(childNode.nodeName) > -1
    })
    //
    Array.prototype.forEach.call(sourceElements, function (node) {
      if (node.hasAttribute('data-mce-style')) {
        node.removeAttribute('data-mce-style')
      }
      loopThroughNodes(node)
    })
    return currentNode.innerHTML
  }
  //
  return loopThroughNodes(source)
}


Message.prototype.updateMainTextRender = function (sourceNode, targetNode) {
  var self = this
  // debug
  if (self.properties.id === 2) {
    console.log('////////////////////////////////\n-updateMainTextRender: ')
  }
  // 
  function loopThroughNodes (source) {
    var allowedTags = [
      'TEXT',
      'P',
      'SPAN',
      'EM',
      'STRONG'
    ]
    // 
    var sourceElements = Array.prototype.filter.call(source.childNodes, function (childNode) {
      return allowedTags.indexOf(childNode.nodeName) > -1
    })
    // 
    sourceElements.forEach(function (node) {
      // debug
      if (node.nodeName == 'SPAN' && node.style) {
        if (self.properties.id === 2) {
          console.log('////////////////////////////////\n-SPAN 1: ')
          console.log(node.outerHTML)          
        }
      }
      if (node.style) {
        loopThroughNodes(node)
        // 
        var fontSize = parseInt(window.getComputedStyle(node, null).getPropertyValue('font-size'))
        console.log('////////////////////////////////\n-SPAN 2 / fontSize: ')
        console.log(fontSize)
        if (fontSize) {
          // debug
          // console.log('////////////////////////////////\n-original fontSize: ' + fontSize + 'px')
          node.style.fontSize = (fontSize * 2) + 'px'
          // debug
          // console.log('////////////////////////////////\n-new fontSize: ' + node.style.fontSize)
          if (node.nodeName == 'SPAN' && self.properties.id === 2) {
            console.log('////////////////////////////////\n-SPAN 2: ' + parseInt(window.getComputedStyle(node, null).getPropertyValue('font-size')))
          }
        }
      }
    })
    return source.innerHTML
  }
  // 
  var docBody = document.querySelector('body')
  var tempNode = document.createElement('DIV')
  tempNode.setAttribute('id', 'temp-node-' + self.properties.id)
  tempNode.style.fontSize = '18px'
  tempNode.style.position = 'absolute'
  tempNode.style.top = '-10000px'
  docBody.appendChild(tempNode)
  // 
  targetNode.innerHTML = ''
  tempNode.innerHTML = ''
  var source = sourceNode.cloneNode(true)
  tempNode.innerHTML = source.innerHTML
  this.cleanUpTinyMceHtml(tempNode)
  // 
  targetNode.innerHTML = loopThroughNodes(tempNode)
  docBody.removeChild(tempNode)
  // debug
  if (self.properties.id === 2) {
    console.log('////////////////////////////////\n-sourceNode')
    console.log(sourceNode.innerHTML)
    console.log('////////////////////////////////\n-tempNode')
    console.log(tempNode.innerHTML)
    console.log('////////////////////////////////\n-targetNode')
    console.log(targetNode.innerHTML)
  }
}


Message.prototype.refreshMainTextStyles = function (id) {
  var mainTextBox = document.querySelector('#main-text-' + id)
  var mainTextRenderBox = document.querySelector('#main-text-render-' + id)
  console.log('////////////////////////////////\n-refreshMainTextStyles')
  console.log(mainTextBox, mainTextRenderBox)
  this.updateMainTextRender(mainTextBox, mainTextRenderBox)
}


Message.prototype.initTextEditor = function () {
  var self = this
  try {
    tinyMCEOptions = {
      selector: 'div#main-text-' + this.properties.id,
      theme: 'inlite',
      insert_toolbar: false,
      // selection_toolbar: 'bold italic underline strikethrough | fontsizeselect | alignleft aligncenter alignright alignjustify',
      selection_toolbar: 'fontsizeselect | alignleft aligncenter alignright alignjustify',
      // selection_toolbar: 'italic underline | fontsizeselect | alignleft aligncenter alignright alignjustify',
      fontsize_formats: '18px 24px 36px 42px',
      // fontsize_formats: '8px 10px 12px 14px 18px 24px 36px 42px',
      inline: true,
      paste_data_images: false,
      setup: function (editor) {
        // 
        editor.on('init', function(){
          if (editor.bodyElement.textContent.length == 0){
            if (self.properties.reducedStyle.mainText.html && self.properties.reducedStyle.mainText.html.length > 0) {
              editor.bodyElement.innerHTML = self.properties.reducedStyle.mainText.html
              self.updateMainTextRender(self.mainText, self.mainTextRender)
            }
            editor.bodyElement.innerHTML = self.properties.reducedStyle.mainText.defaultHtml
          }
        })
        // 
        editor.on('blur', function(){
          if (editor.bodyElement.textContent.length == 0){
            editor.bodyElement.innerHTML = self.properties.reducedStyle.mainText.defaultHtml
            self.properties.fullStyle.mainText.html = ''
          }
        })
        // 
        editor.on('NodeChange', function (e) {
          //
          // var mainTextBoxes = self.getMainTextBox(self.properties.id)
          // console.log('////////////////////////////////////\n-mainTextBoxes: ' + JSON.stringify(mainTextBoxes))
          // self.updateMainTextRender(self.mainText, self.tempNode, self.mainTextRender)
          self.refreshMainTextStyles(self.properties.id)
        })
      }
    }
    //
    window.tinymce.init(tinyMCEOptions)
    return this
  } catch (err) {
    console.error('//////// tiny mce error ////////', err)
  }
}


module.exports = function (pickedTemplate, target, User, APP_NAME, Store, Helper) {
  return new Message(pickedTemplate, target, User, APP_NAME, Store, Helper)
}




//////////////////
// WEBPACK FOOTER
// ./~/annonces-app-modules/controllers/Message.js
// module id = 80
// module chunks = 0